import { Injectable } from '@angular/core';

import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { ModularConfigAccessorService } from '@frontend/sports/widget/core/feature';

import { TabBarItem } from '../tab-bar/tab-bar.models';

@Injectable()
export class NextToGoTrackingService {
    constructor(
        private trackingService: TrackingService,
        private accessorService: ModularConfigAccessorService,
    ) {}

    trackShowMoreClick(expanded: boolean, sportId: number | undefined): void {
        const details = expanded ? 'show more' : 'show less';

        const trackingData = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: `${this.accessorService.getPage()?.toLowerCase()} grid widgets`,
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'widget navigation',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: this.buildLocationEvent(sportId),
            [trackingConstants.COMPONENT_EVENT_DETAILS]: details,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackTabSelected(tab: TabBarItem, index: number): void {
        const trackingData = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: `${this.accessorService.getPage()?.toLowerCase()} grid widgets`,
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'widget navigation',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: 'Sport',
            [trackingConstants.COMPONENT_LOCATION_EVENT]: this.buildLocationEvent(tab.id),
            [trackingConstants.COMPONENT_EVENT_DETAILS]: tab.title,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: index.toString(),
            [trackingConstants.SPORT_ID]: tab.id.toString(),
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackEventClick(event: GridEvent, index: number): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: `${this.accessorService.getPage()?.toLowerCase()} grid widgets`,
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'sport events',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: index.toString(),
            [trackingConstants.COMPONENT_LOCATION_EVENT]: this.buildLocationEvent(event.sport.id),
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'sport event',
            [trackingConstants.SPORT_EVENT_ID]: event.id,
            [trackingConstants.SPORT_ID]: event.sport.id.toString(),
        });
    }

    private buildLocationEvent(sportId: number | undefined): string {
        return [this.accessorService.getPage(), this.accessorService.getWidget()?.templateName, 'sport', sportId]
            .filter((seg) => seg)
            .join('/')
            .toLowerCase();
    }
}
